export const checkAndroidWebView = async () => {
    const response = await fetch(`https://ety6gzpfj7.execute-api.us-east-1.amazonaws.com/web-view-check`, {
        method: 'POST',
        headers: {'content-type': 'application/json'}
    });
    return response.json();
};
